/**
 * Returns a promise that will be resolved after the specified timeout
 */
export async function sleep(timeout: number): Promise<void> {
  return new Promise<void>((resolve) => {
    setTimeout(resolve, timeout);
  });
}
